// src/utils/soundUtils.js
export const SOUND_LIBRARY = {
  card_flip: "/sounds/card_flip.mp3",
  paper_flip: "/sounds/paper_flip.mp3",
  pin_thud: "/sounds/pin_thud.mp3",
  click: "/sounds/button_click.mp3",
  // เพิ่มเสียงอื่นๆ ที่คุณมีในโฟลเดอร์ public/sounds ได้ตามต้องการ
};

export const controlBgm = (audioRef, targetSrc, isMuted, volume = 0.4) => {
  if (isMuted) {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.src = "";
    }
    return;
  }

  if (!targetSrc) {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.src = "";
    }
    return;
  }

  if (!audioRef.current) {
    audioRef.current = new Audio(targetSrc);
    audioRef.current.loop = true;
    audioRef.current.volume = volume;
    audioRef.current.play().catch((e) => console.error("BGM Play Error", e));
  } else if (!audioRef.current.src.includes(targetSrc)) {
    audioRef.current.src = targetSrc;
    audioRef.current.play().catch((e) => console.error("BGM Play Error", e));
  } else {
    audioRef.current.play().catch((e) => {});
  }
};

export const generateRandomCode = (length) => {
  const characters = "0123456789"; // <-- เปลี่ยนเป็นตัวเลขล้วน
  let result = "";
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};
